
import { CardContent } from "@/components/ui/card";
import ProductsTable from "../dashboard/ProductsTable";
import { useProducts } from "@/hooks/useProducts";
import { useProductContext } from "@/context/ProductContext";

const ProductContent = () => {
  const { products, isLoading } = useProductContext();
  const { handleEditProduct, handleDeleteProduct } = useProducts();

  if (isLoading) {
    return <div className="py-4 text-center">Chargement...</div>;
  }

  return (
    <CardContent>
      <ProductsTable
        products={products}
        onEditProduct={handleEditProduct}
        onDeleteProduct={handleDeleteProduct}
      />
    </CardContent>
  );
};

export default ProductContent;
